<div class="table-header table-header-offset-sm table-header-with-controls">
  <div class="table-header-search"></div>

  <div class="table-header-filters"></div>

  <div class="table-header-controls">
    @if (cardAccountId$ | async; as financialAccountId) {
      <button
        rktButton
        btnType="secondary"
        appRemoveFocus
        title="Add an Alert"
        (click)="onCreateAlertBtnClick({ financialAccountId })"
        class="add-entity-btn"
        [disabled]="!!(loading$ | accessControl | async)"
      >
        <rkt-icon name="plus"></rkt-icon>
        Add an Alert
      </button>
    }
  </div>
</div>

<rkt-table
  [rows]="(alerts$ | async)!"
  [columns]="columns"
  [count]="(totalElements$ | async)!"
  [loadingIndicator]="(loading$ | async)!"
  [externalPaging]="false"
  [messages]="{ emptyMessage: 'No Alerts found.' }"
  emptyValuePlaceholder="--"
  dateTimeFormat="MM/dd/yy HH:mm"
  (rowActivated)="onRowClick($event)"
></rkt-table>
